import { defineStore } from "pinia";

export const useCartStore = defineStore("cart-store", {
  state: () => ({
    cart: [],
  }),

  getters: {
    cartItems: (state) => state.cart,

    cartTotal: (state) =>
      state.cart.reduce(
        (total, item) => total + item.sale_price * item.quantity,
        0
      ),

    cartCount: (state) =>
      state.cart.reduce((count, item) => count + item.quantity, 0),
  },

  actions: {
    addToCart(product) {
      const existing = this.cart.find((item) => item.id === product.id);

      if (existing) {
        existing.quantity++;
      } else {
        this.cart.push({
          ...product,
          quantity: 1,
        });
      }
    },

    increaseQty(productId) {
      const item = this.cart.find((i) => i.id === productId);
      if (item) item.quantity++;
    },

    decreaseQty(productId) {
      const item = this.cart.find((i) => i.id === productId);
      if (!item) return;

      if (item.quantity > 1) {
        item.quantity--;
      } else {
        this.removeFromCart(productId);
      }
    },

    removeFromCart(productId) {
      this.cart = this.cart.filter((item) => item.id !== productId);
    },

    clearCart() {
      this.cart = [];
    },
  },
});
